import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Project } from '../project'
import { ProjectService } from '../project.service'
import { PageService } from '../page.service'
import { DbRecord } from '../db-record'
import { DbRecordService } from '../db-record.service'
import { SortService } from '../sort.service'
import { FilterService } from '../filter.service'
import { RuntimeService } from '../runtime.service'

@Component({
  selector: 'app-project-db-records',
  templateUrl: './project-db-records.component.html',
  styleUrls: ['./project-db-records.component.css']
})
export class ProjectDbRecordsComponent implements OnInit {
  project: Project
  _fromYear: string
  _toYear: string
  filterStartYear: number
  filterEndYear: number
  private _filterIsRunning = false


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projects: ProjectService,
    private dbrs: DbRecordService,
    private rts: RuntimeService,
    private pgs: PageService,
    private ss: SortService,
    public fs: FilterService
  ) {
    this.rts.adminType = 'project'
  }

  ngOnInit() {
    this.fs.orTagOn = false
    this.route.params.subscribe(params => {
      this.project = this.projects.get(params['id'])
      this.rts.currentProject = this.project
      if (!this.project)
        return this.router.navigate(['projects'])
      this.project.initProject()
    })
  }

  switchOrTag() {
    this.fs.orTagOn = !this.fs.orTagOn
  }

  get fromYear() {
    return this._fromYear
  }

  get toYear() {
    return this._toYear
  }

  set fromYear(txt) {
    let n = parseInt(txt)
    if (n > 1800 && n < 2100 && n != this.filterStartYear)
      this.filterStartYear = n
    else
      this.filterStartYear = null
    this._fromYear = txt
  }

  set toYear(txt) {
    let n = parseInt(txt)
    if (n > 1800 && n < 2100 && n != this.filterEndYear)
      this.filterEndYear = n
    else
      this.filterEndYear = null
    this._toYear = txt
  }

  get hasManual() {
    return false
  }

  //private _dbRecordsStartRun

  get dbRecords(): DbRecord[] {
    if (this._filterIsRunning)
      return this.projects.recordsCache
    /*let now = Date.now()
    let cacheLs = this.projects.recordsCache
    if (cacheLs &&
      (this._dbRecordsStartRun && (now - this._dbRecordsStartRun < 1500)))
      return cacheLs
    this._dbRecordsStartRun = now
*/
    //console.log("DD FILTER RUN")
    this._filterIsRunning = true
    let ls = this.fs.run(this.dbrs.getProjectDbRecordsList(this.project))
    if (this.filterStartYear)
      ls = ls.filter((x) => x.year >= this.filterStartYear)
    if (this.filterEndYear)
      ls = ls.filter((x) => x.year <= this.filterEndYear)
    let sortedLs = this.ss.run(ls)
    this.projects.recordsCache = sortedLs
    this._filterIsRunning = false
    return sortedLs
  }

  get dbRecordsPage() {
    let ls = this.pgs.getPage(this.dbRecords)
    //  this.fts.checkRecords(ls)
    return ls
  }

  trackByDbRecord(index: number, dbRecord: DbRecord) {
    return dbRecord.id;
  }

  get sortFields() {
    let ls = []
    this.project.criterionsList.forEach((c) =>
      ls.push({ tp: 'criterion', name: c.title, id: c.id }))
    return ls.concat([
      { tp: "dateDesc", name: "Date&#8615;" },
      { tp: "dateAsc", name: "Date&#8613;" },
      { tp: "source", name: "Source" }
    ])
  }


  filterChange(txt) {
    txt = txt.trim()
    if (!txt)
      return this.fs.searchFilter = null
    this.fs.searchFilter = new RegExp(txt, 'ig')
  }

  sourceChange(txt) {
    txt = txt.trim()
    if (!txt)
      return this.fs.sourceFilter = null
    this.fs.sourceFilter = new RegExp(txt, 'ig')
  }

  recordIdChange(txt) {
    txt = txt.trim()
    if (!txt)
      return this.fs.recordIdFilter = null
    this.fs.recordIdFilter = txt
  }


}



// WEBPACK FOOTER //
// ./src/app/project-db-records/project-db-records.component.ts